var map = {
	"./images/Dipesh.jpg": 1751
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1750;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team ^.*\/Dipesh\.jpg$
// module id = 1750
// module chunks = 147